import axios from 'axios'

export default {
  namespaced: true,
  state: {
    commonVatCodeGrid: [],
    commonVatCode: [],
    pageData: null,
  },
  mutations: {
    setCommonVatCodeGrid(state, payload) {
      state.commonVatCodeGrid = payload
    },
    setCommonVatCode(state, payload) {
      state.commonVatCode = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    getCommonVatCode: (state) => {
      return state.commonVatCode
    },
    getCommonVatCodeGrid: (state) => {
      return state.commonVatCodeGrid
    },
    getPageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onCommonVatCodeGrid({commit, rootState}, {limit, page, sort}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url =
        rootState.apiDomain + '/api/admin/common/vat-code/grid?limit=' + limit + '&page=' + page +
        String(sort ? '&order[]=' + sort.param + ':' + sort.value : '&order[]=id:desc')
      return new Promise((resolve, reject) => {
        axios({url, method: 'GET'})
          .then((resp) => {
            commit('setCommonVatCodeGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
            commit('setLoadingAnimationFullPage', false, {root: true})
          })
          .catch((err) => {
            reject(err)
            commit('setLoadingAnimationFullPage', false, {root: true})
          })
      })
    },
    onCommonVatCodeDelete({rootState}, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/vat-code/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonVatCodeUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/vat-code/' + data.id,
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onCommonVatCodeCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/vat-code',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
